export const SITE_ORIGIN = ((import.meta.env.VITE_SITE_URL as string | undefined) || '').replace(/\/+$/, '');

export function siteUrl(path: string): string {
  return `${SITE_ORIGIN}${path}`;
}